export default {
  title: 'Workspaces',
  subtitle: "Every workspace of the organization, including those you're not a member of.",
  create: 'New workspace',
  stats: {
    all: 'Workspaces',
    allHint: 'in the organization',
    public: 'Public',
    publicHint: 'visible to members',
    private: 'Private',
    privateHint: 'invitation only',
    pool: 'Shared pool',
    poolHint: 'shared media',
    storage: 'Total storage',
    storageHint: 'no inactive workspace | 1 inactive workspace | {count} inactive workspaces',
  },
  filters: {
    label: 'Visibility',
    all: 'All',
    public: 'Public',
    private: 'Private',
    pool: 'Shared pool',
    dormant: 'No activity for 6 months',
    search: 'Search a workspace or an owner',
  },
  table: {
    name: 'Workspace',
    visibility: 'Visibility',
    members: 'Members',
    assets: 'Media',
    storage: 'Storage',
    duration: 'Duration',
    lastActivity: 'Last activity',
    owner: 'Owner: {name}',
    ownerGone: 'Owner: deleted account',
    never: 'Never',
    empty: 'No workspace matches these filters.',
  },
  visibility: {
    public: 'Public',
    private: 'Private',
    pool: 'Shared pool',
  },
  actions: {
    label: 'Workspace actions',
    open: 'Open the workspace',
    members: 'Manage members',
  },
  footer: '{shown} workspace shown out of {total} · {size} | {shown} workspaces shown out of {total} · {size}',
  storageNote: 'Storage: originals, encoded versions and thumbnails of every media listed in the workspace.',
}
